import {
  animate,
  group,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input } from '@angular/core';

/**
 * Collapsible container
 */
@Component({
  standalone: true,
  selector: 'ct-lib-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss'],
  host: {
    '[class.open]': 'open',
    '[class.closed]': '!open',
  },
  animations: [
    trigger('collapse', [
      state(
        'open',
        style({
          height: '*',
          paddingTop: '*',
          paddingBottom: '*',
          overflow: 'inherit',
          opacity: 1,
          transform: 'inherit'
        })
      ),
      state(
        'closed, void',
        style({
          height: 0,
          paddingTop: 0,
          paddingBottom: 0,
          overflow: 'hidden',
          opacity: 0,
          transform: 'scale(0.995)'
        })
      ),
      transition(
        'open => closed',
        group([animate('0.3s ease'), style({ overflow: 'hidden' })])
      ),
      transition(
        'closed => open',
        group([animate('0.3s ease'), style({ overflow: 'inherit' })])
      ),
    ]),
  ],
})
export class CollapseComponent {
  @Input() open = false;
}
